const TYPE_OF_MAIN_CONTAINER_INSIDE_POPUP = 'wysiwyg.viewer.components.PopupContainer'
const TYPE_OF_BUILDER_SYSTEM_POPUP_CONTAINER = 'wixSystemElements.PopupContainer'

export const POPUP_CONTAINER_TYPES = new Set([
    TYPE_OF_MAIN_CONTAINER_INSIDE_POPUP,
    TYPE_OF_BUILDER_SYSTEM_POPUP_CONTAINER
])

export const POPUP_CONTAINER = {
    MAIN: TYPE_OF_MAIN_CONTAINER_INSIDE_POPUP,
    BUILDER_SYSTEM: TYPE_OF_BUILDER_SYSTEM_POPUP_CONTAINER
}
